import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLoveFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M3.21875 10.25C2.4375 9.46875 2 8.375 2 7.25C2 4.90625 3.875 3 6.21875 3C7.34375 3 8.4375 3.46875 9.21875 4.25L10 5L10.75 4.25C11.5312 3.46875 12.625 3 13.75 3C16.0938 3 18 4.90625 18 7.25C18 8.375 17.5312 9.46875 16.75 10.25L16 11L10 17L4 11L3.21875 10.25Z"
	})
});
const ForwardRef = forwardRef(SvgLoveFilled);
export default ForwardRef;
